<template>
  <BaseSection>
    <template #header>
      <BaseTitle
        tag="h1"
        size="xl"
        is-medium
        data-animation="fadeInRight"
        data-animation-delay="100"
        text="Полезные приложения для&nbsp;тех, кто работает из дома"
      />
    </template>
    <template #content>
      <div class="section__cards">
        <BaseCard
          v-for="(card, i) in cards"
          :key="`card_${card.id}`"
          v-bind="card"
          class="section__card"
          data-animation="fadeInBottom"
          :data-animation-delay="300 + (i * 300)"
        />
      </div>
    </template>
  </BaseSection>
</template>

<script>
import pageMixin from '@/mixins/page';
import BaseSection from '@/components/BaseSection.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseCard from '@/components/BaseCard.vue';

export default {
  name: 'AppsPage',
  mixins: [pageMixin],
  components: {
    BaseSection,
    BaseTitle,
    BaseCard,
  },
  staticData: () => ({
    cards: [
      {
        id: 'dog',
        title: 'Down Dog Meditation',
        text: 'помогает в&nbsp;любой момент выйти из&nbsp;тревожной или стрессовой ситуации и&nbsp;организовать осознанный перерыв.',
        links: {
          ios: 'https://apps.apple.com/ru/app/%D0%BC%D0%B5%D0%B4%D0%B8%D1%82%D0%B0%D1%86%D0%B8%D1%8F-%D0%B8-%D1%81%D0%BE%D0%BD-down-dog/id1531036966',
          android: 'https://play.google.com/store/apps/details?id=com.downdogapp.meditation&hl=ru&gl=US',
        },
      },
      {
        id: 'noisli',
        title: 'Noisli',
        text: 'генерирует фоновые звуки, которые помогают маскировать раздражающие шумы, чтобы держать ваш ум свежим, улучшить концентрацию внимания и&nbsp;повысить производительность труда.',
        links: {
          ios: 'https://apps.apple.com/ru/app/noisli/id862773459',
          android: 'https://play.google.com/store/apps/details?id=com.noisli.noisli&hl=ru&gl=US',
        },
      },
      {
        id: 'booster',
        title: 'Focus Booster',
        text: 'поможет разобраться, как вы используете своё время, и&nbsp;в&nbsp;результате максимизировать свою производительность.',
        links: {
          site: 'https://www.focusboosterapp.com/',
          ios: '',
          android: '',
        },
      },
      {
        id: 'brain',
        title: 'Brain.fm',
        text: 'музыка для улучшения концентрации, для медитации и&nbsp;сна. Точно так же, как визуальный дизайн офиса или спальни должен улучшать их функциональность, музыка, которую вы слушаете, должна также способствовать достижению ваших целей.',
        links: {
          ios: 'https://apps.apple.com/ru/app/brain-fm-focus-music/id1110684238',
          android: 'https://play.google.com/store/apps/details?id=com.brainfm.app&hl=ru&gl=US',
        },
      },
      {
        id: 'carrot',
        title: 'Carrot Fit',
        text: 'спортивное приложение с&nbsp;виртуальным тренером, который жестко подкалывает пользователя. Хоть посмеетесь, если вдруг не добьетесь успехов в&nbsp;поддержании формы.',
        links: {
          ios: 'https://apps.apple.com/ru/app/carrot-fit/id769155678',
          android: '',
        },
      },
    ],
  }),
};
</script>
